// This file was generated by "make codegen/iam". DO NOT EDIT.
import { allowedActions } from "./allowedActions";

export const roleSpaceMember = {
  id: "space-member",
  mrn: "//iam.api.mondoo.app/roles/space-member",
  title: "Space Member",
  allowedActions,
} as const;

export type RoleSpaceMember = typeof roleSpaceMember;
